import { GET_SNAPSHOT, RESET_SNAPSHOT} from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface getSnapShotState extends BaseAsyncReducerState {
    snapShotInfo?: Record<string, unknown>;
}
// Define an initial state value for the app
const initialState: getSnapShotState  = {
    loading: false,
    error: false
}


function getSnapShotReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_SNAPSHOT.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_SNAPSHOT.SUCCESS:
            return {
                ...state,
                snapShotInfo: payload,
                loading: false,
                error: false

            }
        case GET_SNAPSHOT.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_SNAPSHOT:
            return {
                ...state,
                snapShotInfo: null
            }
        default:
            return state
        }
}

export default getSnapShotReducer;